import { useReduxState } from 'hooks';
import { getMessageWithPlaceholders } from 'shared-locales';
import { PageHeader } from 'components/page';

const HomeGuestHeader = () => {
  const { messages, user } = useReduxState();

  const hours = new Date().getHours();

  const greeting = user?.firstName
    ? getMessageWithPlaceholders({
        message:
          hours < 6
            ? messages.homePageGreetingDefault
            : hours < 12
            ? messages.homePageGreetingMorning
            : hours < 17
            ? messages.homePageGreetingAfternoon
            : hours < 22
            ? messages.homePageGreetingEvening
            : messages.homePageGreetingDefault,
        placeholders: { name: user?.firstName }
      })
    : hours < 6
    ? messages.homePageGreetingDefaultGuest
    : hours < 12
    ? messages.homePageGreetingMorningGuest
    : hours < 17
    ? messages.homePageGreetingAfternoonGuest
    : hours < 22
    ? messages.homePageGreetingEveningGuest
    : messages.homePageGreetingDefaultGuest;

  return <PageHeader icon="home" title={greeting}></PageHeader>;
};

export default HomeGuestHeader;
